export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const MAIL_OK = 'MAIL_OK';
export const MAIL_NOTOK = 'MAIL_NOTOK';
export const CLEAR_MAILERROR = 'CLEAR_MAILERROR';
export const ROBOT_CHECKED = 'ROBOT_CHECKED';
export const PW_UPDATED = 'PW_UPDATED';
export const PW_ERROR = 'PW_ERROR';
export const CODE_OK = 'CODE_OK';
export const CODE_ERR = 'CODE_ERR';
export const RETRY_FAIL = 'RETRY_FAIL';
